module.exports = __webpack_public_path__ + "static/ciarp-2b4b33fac191420d40fd775f4fd4c0d5.jpg";